import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "App-Terms-Nav" }
const _hoisted_2 = { class: "App-Terms-Nav-Desc" }
const _hoisted_3 = { class: "App-Terms-Nav-Desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_space, {
        alignment: "flex-start",
        direction: "vertical",
        size: 6
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: link.url,
              key: link.url
            }, {
              default: _withCtx(({ isExactActive }) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  class: _normalizeClass(["App-Terms-Nav-M", isExactActive ? 'Active' : 'Inactive']),
                  icon: "el-icon-circle-check"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(link.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _: 1
      }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { "m-t-3": "" }, [
        _createElementVNode("div", { "txt-center": "" }, [
          _createElementVNode("span", { "mute-secondary": "" }, "Other Links")
        ])
      ], -1)),
      _createVNode(_component_el_space, {
        alignment: "flex-start",
        direction: "vertical",
        size: 6
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherLinks, (link) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: link.url,
              key: link.url
            }, {
              default: _withCtx(({ isExactActive }) => [
                _createVNode(_component_el_button, {
                  class: _normalizeClass([isExactActive ? 'Active' : 'Inactive', "App-Terms-Nav-M"]),
                  type: "text",
                  icon: "el-icon-circle-check"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(link.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}